import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {
    IGameContextViewModel
} from "../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";
import {observer} from "mobx-react";
import {GameIframeBox} from "./boxes/iframe/game-iframe.box";
import {CyClass} from "../../../../common/cy-classes";

interface GameBodyComponentProps {
    gameContext: IGameContextViewModel;
    onGameIframeElementCreated: (element: HTMLIFrameElement) => void;
}

export const GenericGameBodyComponent = observer(
    class GenericGameBodyComponent extends OrbitComponent<GameBodyComponentProps> {

        private _captureIframeElementRef = (element: HTMLIFrameElement) => {
            this.props.onGameIframeElementCreated(element);
        }

        render() {
            let maxWidth = 'unset';
            let maxHeight = 'unset';
            if(this.props.gameContext.isGameResizable) {
                maxWidth = this.props.gameContext.gameSize.width + 'px';
                maxHeight = this.props.gameContext.gameSize.height + 'px';
            }

            return (
                <GameIframeBox src={this.props.gameContext.launchGameUrl}
                               maxWidth={maxWidth}
                               maxHeight={maxHeight}
                               allowFullScreen={false}
                               allow='autoplay'
                               scrolling='yes'
                               ref={this._captureIframeElementRef}
                               className={CyClass('cy-game-iframe')}/>
            )
        }
    }
);